/**
 * Managed-service pricing constants — fill these in when the numbers are finalised.
 * Referenced by ServicePricingCard, Auth landing, Pricing page, and localized landings.
 *
 * TODO(pricing): replace TODO values with confirmed retainer + per-meeting numbers,
 * and set STRATEGY_CALL_URL to the real booking link.
 */
export const SERVICE_PRICING = {
  retainerMonthly: 1500, // TODO_PRICE_RETAINER (USD/mo)
  perQualifiedMeeting: 250, // TODO_PRICE_PER_MEETING (USD)
  currency: "USD" as const,
  freeFirstMeeting: true,
  strategyCallUrl: "/auth?intent=signup", // TODO_STRATEGY_CALL_URL — swap for Calendly / SavvyCal
};

export function formatUsd(n: number) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n);
}
